<template>
  <div>
    <van-skeleton title animate :row="15" round="true" :loading="loading_ske">
      <Scroll height="800" class="hideGd">
        <Button type="warning" class="qx05" icon="ios-create-outline" @click="addAuth">添加权限</Button>
        <Collapse v-model="value1" disabled>
          <Panel v-for="(item,index) in data" :key="'po'+index" disabled>
            {{item.name}}
            <Icon type="ios-add-circle-outline" class="qx03" @click="addZjAuth(item)" title="添加子级权限"/>
            <Icon type="md-build" @click="editAuthName(item)" title="编辑权限"/>
            <div class="qx01" slot="content">
              <div class="qx02" v-for="(items,indexs) in item.sonList" :key="'pos'+indexs">
                {{items.name}}
                <Icon type="ios-create-outline" size="20" class="qx03 qx04" @click="editAuth(items)"/>
              </div>
            </div>
          </Panel>
        </Collapse>

        <Modal v-model="modal2" width="360">
          <p slot="header" style="color:#f60;text-align:center">
            <Icon type="ios-information-circle"></Icon>
            <span>删除权限</span>
          </p>
          <div style="text-align:center">
            <p>删除权限后将不可恢复，请谨慎操作.</p>
            <p>是否继续？</p>
          </div>
          <div slot="footer">
            <Button type="error" size="large" long :loading="modal_loading" @click="del">删除</Button>
          </div>
        </Modal>
      </Scroll>
    </van-skeleton>
  </div>
</template>

<script>
  import httpAuth from "@/api/auth";
  import util from "../../util/util";
  export default {
    data() {
      return {
        values:'1',
        value1: [],           //权限下标
        data:[],              //权限列表
        modal2: false,        //删除框
        item:[],              //当前选中item
        itemIndex:'',         //当前选中item下标
        zjIndex:'',           //当前选中item子级下标
        modal_loading: false, //是否加载
        loading:false,        //是否加载
        caidan: '',           //修改菜单名称
        loading_ske:true,     //骨架屏显示
      }
    },
    mounted() {
    },
    created() {
      //获取权限列表数据
      var me = this;
      let user = JSON.parse(sessionStorage.getItem('user'));
      let data = {
        mobile:user.mobile,
        sign:user.sign,
        companyId:user.companyId
      };
      httpAuth.authList(data).then(res => {
        switch (res.code) {
          case "0000":
            me.data = res.data;
            me.loading_ske = false;
            me.data.forEach(function (item,index) {
              me.value1.push(''+index+'');
            })
            console.log(me.value1);
            break;
          default:
            me.$message.error('系统错误');
            break;
        }
      });
    },
    methods: {
      editAuthName(item){//修改权限名称
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'权限管理','编辑顶级权限');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$router.push({name:'EditAuthName',params:{id:item.id,name:item.name,code:item.code,icon:item.icon}})
      },
      addAuth() {//添加顶级权限
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'权限管理','添加顶级权限');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        this.$router.push('/auth/AddAuth');
      },
      addZjAuth(item) {//添加子级权限
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'权限管理','添加子级权限');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        this.$router.push({name:'AddZjAuth',params:{pid:item.id}});
      },
      editAuth(item){//编辑权限
        var me = this;
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth =  util.is_Auth(menu,'权限管理','编辑子级权限');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        this.$router.push({name:'AddZjAuth',params:{id:item.id,name:item.name,url:item.url,order:item.code,types:item.type}});
      },
      delAuth(item,index,indexs){//删除权限
        var me = this;
        me.modal2 = true;
        me.item = item;
        me.itemIndex = index;
        me.zjIndex = indexs;
      },
      del(){//点击删除按钮
        var me = this;
        me.modal_loading = true;
        let user = JSON.parse(sessionStorage.getItem('user'));
        let data = {
          userId:user.id,
          sign:user.sign,
          id:me.item.id,
          mobile:user.mobile,
        };
        http.delAuth(data).then(res => {
          if (res.status == 10011) {
            me.data[me.itemIndex].zjList.splice(me.zjIndex,1);
            me.modal_loading = false;
            me.modal2 = false;
            me.$message.success(res.message);
          } else {
            me.modal_loading = false;
            me.modal2 = false;
            me.$message.error(res.message);
          }
        })
      }
    }
  }
</script>

<style>
  @import "AuthList.css";
</style>
